export const TAB_NAME = {
  TRANSCRIPT: 'Transcript',
  CARE_CUES: 'CareCues',
  PREFERENCES: 'Preferences',
  TEMPLATES: 'Templates',
};
